// @flow

import { useController } from 'react-hook-form';

import {
  type SelectProps,
  Select as ReshapedSelect,
  type ChangeHandlerArgsValue,
} from 'reshaped';

import { FieldWrapper } from './FieldWrapper';
import { Options } from './Options';
import type { Item, Items } from './Options';
import type { FieldProps } from './types';

export type Props = {
  ...FieldProps<SelectProps>,

  // props that have evoluated
  options: Items,
  selectProps?: Partial<SelectProps>,

  // ex-Select props
  /** WARN not fully implemented. It disables the field */
  loading?: boolean,
  placeholder?: string,
};

function getKey(option: Item, i: number): string {
  // Use i because same value can be used multiple times in multi-select
  return `${Array.isArray(option.value) ? option.value.join(',') : option.value}${i}`;
}

export function Select({
  loading,
  name,
  options,
  placeholder,
  label,
  help,
  disabled,
  control,
  rules,
  inputProps,
  inputAttributes,
  required,
  onChange,
  selectProps,
  ...extraProps
}: Props): React.MixedElement {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <FieldWrapper
      fieldState={fieldState}
      label={label}
      help={help}
      {...extraProps}
    >
      {/* $FlowFixMe[incompatible-type] */}
      <ReshapedSelect
        name={name}
        // Workaround to fix the select; should be removed when `children` props works by itself
        options={[]}
        value={field.value}
        onChange={(
          e: ChangeHandlerArgsValue<string, SyntheticEvent<HTMLInputElement>>,
        ) => {
          // update the form field
          field.onChange(e.value);
          // update the parent for chain changes
          if (typeof onChange === 'function') onChange(e);
        }}
        placeholder={placeholder}
        disabled={disabled || loading}
        inputAttributes={{
          ...inputAttributes,
          // size="large" not working
          style: { height: 'revert' },
        }}
        size="large"
        {...selectProps}
      >
        {options.map((option, index) => (
          <Options option={option} key={getKey(option, index)} />
        ))}
      </ReshapedSelect>
    </FieldWrapper>
  );
}
